import { useGetUserInfoQuery } from "../../app/rootReducer";

export const useRefurbishedShopEnabled = (): {
    refurbishedShopEnabled: boolean;
    isUserLoading: boolean;
} => {
    const { data, isLoading, isFetching } = useGetUserInfoQuery();

    return {
        refurbishedShopEnabled: data?.refurbishedShopEnabled ?? false,
        isUserLoading: isLoading || (isFetching && data === undefined),
    };
};
